import CardSearchProduct from "@fdn/card_search_product";

import vars from "Consts/vars";
import handleLoadMoreLabel from "Helpers/loadMore";
import SortSearch from "../../sort/sort";

const Desktop = (props) => {

	const prop = props;

	const limitData = 24;

	return (
		<div className="component-tab-product">
			{
				prop.dataProduct?.data?.products.length > 0 ? (
					<>
						<div className="component-tab-product__section-title">
							<p className="component-tab-product__title title-product">Products</p>
							<div className="component-tab-product__button-view-all" type="button">
								<SortSearch isMobile={prop.isMobile} handleSorting={prop.handleSorting} />
							</div>
						</div>
						<div className="component-tab-product__product">

							{
								prop.dataProduct?.data?.products.map((data) => (
									<CardSearchProduct
										key={data?.id}
										isMobile={prop.isMobile}
										maxWidth="300px"
										data={{
											variant: data?.name,
											name: data?.product?.name || "-",
											brand: data?.brand?.name || "-",
											image: data?.assets[0].url || vars.no_image,
											rating: data.rating?.rating_overall || 0,
											totalRating: data.total_review || 0,
											url: Array.isArray(data?.categories)
											&& data?.categories.length > 0
												? `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/products/${data?.categories[0]?.parent?.slug}/
												${data?.categories[0]?.slug}/${data?.brand?.slug}/${data?.slug}`
												: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
										}}
									/>

								))
							}
						</div>
						{
							prop.dataProduct?.data?.products.length < prop.dataProduct?.pagination.total && (
								<div className="component-tab-product__section-more-data">
									<button
										type="button"
										className="component-tab-product__title-more-data"
										onClick={prop.handleLoadMoreProduct}
										id="id-loadmore"
									>
										{handleLoadMoreLabel({
											page: prop.dataProduct?.pagination.page,
											limit: limitData,
											total: prop.dataProduct?.pagination.total,
											data: prop.dataProduct?.data?.products,
											text: "Product",
										})}
									</button>
								</div>
							)
						}

					</>
				) : (
					<div className="component-tab-product__section-image-error">
						<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-product__image-error" />
						<h4 className="component-tab-product__title">Sorry, no result found</h4>
						<p className="component-tab-product__sub_title">Please try another keyword!</p>
					</div>
				)
			}

			<style jsx>
				{`
						.component-tab-product{
							padding-top: 10px;
							max-width: 1280px;
							margin: auto;
						}
						.component-tab-product__section-title{
							display: flex;
							margin-top: 36px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.component-tab-product__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.component-tab-product__product{
							display: grid;
  							grid-template-columns: repeat(3, 1fr);
							gap: 12px;
						}
						.component-tab-product__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.component-tab-product__section-more-data{
							display: flex;
    						justify-content: center;
							margin-top: 24px;
						}
						.component-tab-product__title-more-data{
							font-family: 'Creato Display', sans-serif;
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							text-align: center;
							padding: 8px 16px;
							background: #fff;
							border: 1px solid #000;
							border-radius: 8px;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}
						.component-tab-product__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-product__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;

						}
						.component-tab-product__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-product__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Desktop;
